/**
 * @generated SignedSource<<219d6e750157cce42c79cfe6244b787b>>
 * @relayHash a257abce916a26f7699fb7e4c0f4279d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cbc12d9ffa0baed4606f9ee3a5ee29fd405e313290d45b5ebcd78893563e3fca

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceAggregationDimension = "PERFORMANCE_RATING" | "%future added value";
export type useContentPerformanceSummaryQuery$variables = {
  aggregateDimension: ConfluenceAggregationDimension;
  cloudId: string;
  endTimestamp: string;
  spaceId?: string | null | undefined;
  startTimestamp: string;
};
export type useContentPerformanceSummaryQuery$data = {
  readonly confluence_contentPerformanceSummary: {
    readonly distribution: {
      readonly buckets: ReadonlyArray<{
        readonly count: number;
        readonly definition: {
          readonly max: number | null | undefined;
          readonly min: number | null | undefined;
          readonly unit: string;
        };
        readonly key: string;
        readonly percentage: number | null | undefined;
      } | null | undefined>;
    };
    readonly totalContent: number;
  } | null | undefined;
};
export type useContentPerformanceSummaryQuery = {
  response: useContentPerformanceSummaryQuery$data;
  variables: useContentPerformanceSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregateDimension"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTimestamp"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTimestamp"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "aggregateDimension",
        "variableName": "aggregateDimension"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "endTimestamp",
        "variableName": "endTimestamp"
      },
      {
        "kind": "Variable",
        "name": "spaceId",
        "variableName": "spaceId"
      },
      {
        "kind": "Variable",
        "name": "startTimestamp",
        "variableName": "startTimestamp"
      }
    ],
    "concreteType": "ConfluenceContentPerformanceSummary",
    "kind": "LinkedField",
    "name": "confluence_contentPerformanceSummary",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "totalContent"
      },
      {
        "concreteType": "ConfluencePerformanceDistribution",
        "kind": "LinkedField",
        "name": "distribution",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluencePerformanceBucket",
            "kind": "LinkedField",
            "name": "buckets",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "concreteType": "ConfluenceBucketDefinition",
                "kind": "LinkedField",
                "name": "definition",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "min"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "max"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "unit"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "kind": "ScalarField",
                "name": "percentage"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentPerformanceSummaryQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentPerformanceSummaryQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "a257abce916a26f7699fb7e4c0f4279d",
    "id": "cbc12d9ffa0baed4606f9ee3a5ee29fd405e313290d45b5ebcd78893563e3fca",
    "metadata": {},
    "name": "useContentPerformanceSummaryQuery",
    "operationKind": "query",
    "text": "query useContentPerformanceSummaryQuery($cloudId:ID!,$startTimestamp:String!,$endTimestamp:String!,$spaceId:ID,$aggregateDimension:ConfluenceAggregationDimension!){confluence_contentPerformanceSummary(cloudId:$cloudId,startTimestamp:$startTimestamp,endTimestamp:$endTimestamp,spaceId:$spaceId,aggregateDimension:$aggregateDimension){totalContent,distribution{buckets{key,definition{min,max,unit},count,percentage}}}}"
  }
};
})();

(node as any).hash = "3de1af4ccbf435feb22c90a878a871c1";

export default node;
